import ServiceBase from '@/services/ServiceBase';

const resource = 'api/v1/group';

class GroupService extends ServiceBase {
  constructor() {
    super({ resource });
  }
}

export default GroupService;



// WEBPACK FOOTER //
// ./src/services/GroupService.js